import { render, staticRenderFns } from "./exhibition-project.vue?vue&type=template&id=a947f8b6&scoped=true&"
import script from "./exhibition-project.vue?vue&type=script&lang=js&"
export * from "./exhibition-project.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-project.vue?vue&type=style&index=0&id=a947f8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a947f8b6",
  null
  
)

export default component.exports